// 封装ajax方法
import $jsonurl from 'api-url'
import { Ajax, OutAjax } from './ajax-base'
import Config from 'config'

let defaultConfig = {
  noToken: false
}

// ajax get 方法
const get = function (options, config) {
  if (options.data && options.data.data) {
    options.url = `${options.url}?data=${encodeURI(JSON.stringify(options.data.data))}`
  }
  return Ajax.get(options.url, config)
  // return Ajax.get(options.url, {params: options.data}, Object.assign(defaultConfig, config))
}

// ajax post
const post = function (options, config) {
  return Ajax.post(options.url, options.data, Object.assign({}, defaultConfig, config))
}

const put = function (options, config) {
  return Ajax.put(options.url, options.data, Object.assign({}, defaultConfig, config))
}

const _delete = function (options, config) {
  return Ajax.delete(options.url, options.data, Object.assign({}, defaultConfig, config))
}

const upload = function (options, type) {
  let token = ''
  let formData = new FormData()
  formData.append('file', options)
  return get({
    url: $jsonurl.open.getToken + '?type=' + type
  }).then((res) => {
    token = res.data.token
    formData.append('token', token)
    return OutAjax.post(Config.service.qiniuUpload, formData)
  })
}

export default {get, put, post, delete: _delete, upload}



// WEBPACK FOOTER //
// ./src/common/utils/ajax.js